import { useEffect } from 'react';
import { useDbtAltCoinsObFeatureFlag } from '@paradigm/features/src/feature-flags/context';
import {
  DBT_ALT_COINS_PRODUCT_CODES,
  PRODUCTS,
} from '@paradigm/features/src/products/config';
import { useProductsStore } from '@paradigm/features/src/products/store';
import { getProduct } from '@paradigm/features/src/products/domain';

/**
 * Mark alt coins as enabled. Skip permanently retired products
 * (isDisabled in config).
 */
export default function useIncludeDbtAltCoins() {
  const isDbtAltCoinsObEnabled = useDbtAltCoinsObFeatureFlag();
  const updateProduct = useProductsStore((s) => s.updateProduct);

  useEffect(() => {
    DBT_ALT_COINS_PRODUCT_CODES.forEach((productCode) => {
      const product = getProduct(productCode);
      if (product.kind !== 'OPTION') return;
      // Don't re-enable permanently retired products (e.g. MT, MA)
      const configProduct = PRODUCTS[productCode];
      if (configProduct?.isDisabled === true) return;
      updateProduct(productCode, {
        isDisabled: false,
        isDisabledForOb: !isDbtAltCoinsObEnabled,
      });
    });
  }, [isDbtAltCoinsObEnabled, updateProduct]);
}
